import React from "react";
import { ReactComponent as CloseSvg } from "../svgs/close.svg";
import { ReactComponent as GuidanceIllustrationSvg } from "../svgs/guidance-illustration.svg";
import exampleNonConform from "../images/example-non-conform.jpg";
import exampleScaleReading from "../images/example-scale-reading.png";
import examplePackage from "../images/example-package.png";
import bucket2 from "../images/bucket2.png";
import bucket3 from "../images/bucket3.png";
import bucket4 from "../images/bucket4.png";
import bucket5 from "../images/bucket5.png";
import bucket6 from "../images/bucket6.png";

export const PhotoGuidance = ({
  onClose,
  currentStep,
  bucketTitle,
  bucketPlaceholder,
}) => {
  // Always use the same instructions
  const instructions = [
    { number: 1, text: "Make sure all items are in frame" },
    { number: 2, text: "Make sure the picture is not blurred" },
  ];

  // Determine which image and title to show based on current step
  let exampleImage = exampleNonConform;
  let title = "Example Non-Conform Photo";

  if (currentStep === "Sort Contents") {
    // Check bucket title to determine which image to use
    if (
      bucketTitle?.includes("Bucket 2") ||
      bucketTitle?.includes("bucket 2")
    ) {
      exampleImage = bucket2;
    } else if (
      bucketTitle?.includes("Bucket 3") ||
      bucketTitle?.includes("bucket 3")
    ) {
      exampleImage = bucket3;
    } else if (
      bucketTitle?.includes("Bucket 4") ||
      bucketTitle?.includes("bucket 4")
    ) {
      exampleImage = bucket4;
    } else if (
      bucketTitle?.includes("Bucket 5") ||
      bucketTitle?.includes("bucket 5")
    ) {
      exampleImage = bucket5;
    } else if (
      bucketTitle?.includes("Bucket 6") ||
      bucketTitle?.includes("bucket 6")
    ) {
      exampleImage = bucket6;
    } else if (bucketPlaceholder) {
      // Use placeholder for first bucket or any other bucket
      exampleImage = bucketPlaceholder;
    }
    title = `Example ${bucketTitle} Photo`;
  } else if (currentStep === "Package Photo") {
    exampleImage = examplePackage;
    title = "Example Package Photo";
  } else if (currentStep === "Photo Non-Conform Overview") {
    exampleImage = exampleNonConform;
    title = "Example Non-Conform Photo";
  } else if (currentStep === "Photo Scale Reading") {
    exampleImage = exampleScaleReading;
    title = "Example Scale Reading Photo";
  }

  return (
    <div className="fixed inset-0 z-[100] bg-[#030711] flex flex-col">
      {/* Header */}
      <div className="bg-[#060E23]/94 border-b border-[#282F44]">
        <div className="flex items-center justify-between px-6 py-6">
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-[#282F44]/20 transition-colors"
          >
            <CloseSvg className="w-8 h-8 fill-white" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-8 py-8">
        <div className="flex gap-8 max-w-[1200px] w-full">
          {/* Left side - Instructions */}
          <div className="flex flex-col items-center gap-10 flex-1">
            <GuidanceIllustrationSvg />
            <div className="bg-[#060E23] rounded-3xl p-8 w-[434px]">
              <h2 className="text-xl font-bold text-[#E6ECFF] mb-6">
                Follow these instructions
              </h2>

              <div className="flex flex-col gap-6">
                {instructions.map((instruction) => (
                  <div
                    key={instruction.number}
                    className="flex items-center gap-4"
                  >
                    <div className="w-6 h-6 bg-[#173991] rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-lg">
                        {instruction.number}
                      </span>
                    </div>
                    <p className="text-[#E6ECFF] text-base">
                      {instruction.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right side - Example photo */}
          <div className="flex flex-col items-center gap-6 flex-1">
            <img
              src={exampleImage}
              alt={title}
              className="w-[434px] h-[290px] object-cover rounded-xl"
            />
            <h3 className="text-xl font-bold text-[#E6ECFF]">{title}</h3>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="backdrop-blur-lg bg-black/10 px-8 py-8">
        <button
          onClick={onClose}
          className="w-full h-20 bg-[#173991] text-white font-bold text-xl rounded-xl hover:bg-[#1e4bb8] transition-colors shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),inset_0px_-1px_1px_0px_rgba(0,0,0,0.16)]"
        >
          Close
        </button>
      </div>
    </div>
  );
};
